import React, { useEffect, useRef, useState } from 'react';
import { Box, Button, Menu, MenuItem, Paper, Tooltip, Typography } from '@mui/material';
import WorkIcon from '@mui/icons-material/Work';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { useDispatch, useSelector } from 'react-redux';
import { useSearchParams } from 'react-router-dom';
import JobsFilter from './components/JobsFilter';
import JobsTable from './components/JobsTable';
import JobsBoard from './components/JobsBoard';
import JobsCards from './components/JobsCards';
import JobsViewToggle from './components/JobsViewToggle';
import JobsStatusToggle from './components/JobsStatusToggle';
import AnimatedNumbers from "react-animated-numbers";

import Progress from '../../components/Loader/Progress ';
import { getMangeDataAction } from '../../actions/mangeActionV2';
import JobsSortToggle from './components/JobsSortToggle';
import DatePresetsToggle from './components/DatePresetsToggle';
import { getCount } from '../../actions/getCountAction';
import { exportJobsResultsPDF } from '../../util/exportUtils';

function Jobs() {
  const dispatch = useDispatch();
  const [searchParams, setSearchParams] = useSearchParams();
  const dataGridPaperRef = useRef(null);
    const [anchor] = useState(null);
    const countReducer = useSelector((state) => state.fetchCount);
  const [isConfirmDialogOpen, setConfirmDialogOpen] = useState(false);
  const [printMenuAnchor, setPrintMenuAnchor] = useState(null);

  const jobsLegacy = useSelector((state) => state.manageV2);

  // Ensure default PageSize
  useEffect(() => {
  const next = new URLSearchParams(searchParams);
  let changed = false;
  if (!next.get('Status')) { next.set('Status', 'Preparing Vehicles'); changed = true; }
  if (!next.get('View')) { next.set('View', 'board'); changed = true; }
  if (!next.get('PageSize')) { next.set('PageSize', '5'); changed = true; } 
  if (!next.get('StartDate')) { next.set('StartDate', new Date().toISOString().split('T')[0]); changed = true; }
  if (!next.get('EndDate')) { next.set('EndDate', new Date().toISOString().split('T')[0]); changed = true; }

  if (changed) setSearchParams(next);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Stable primitives for hook deps
  const deps = React.useMemo(() => ({
    pageSize: searchParams.get('PageSize'),
    pageNumber: searchParams.get('PageNumber'),
    sortOrder: searchParams.get('SortOrder'),
    sortBy: searchParams.get('SortBy'),
    mixSearch: searchParams.get('MixSearch'),
    status: searchParams.get('Status'),
    startDate: searchParams.get('StartDate'),
    endDate: searchParams.get('EndDate'),
  }), [searchParams]);

  // Fetch jobs when URL query changes (same pattern used across the app)
  useEffect(() => {

  if ( searchParams.toString().length > 0 ){
  dispatch(getMangeDataAction({ mode: 'job', query: searchParams.toString() }));
  }
   dispatch(getCount({ mode: "job" }))
  
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    deps.pageSize,
    deps.pageNumber,
    deps.sortOrder,
    deps.sortBy,
    deps.mixSearch,
    deps.status,
    deps.startDate,
    deps.endDate,
  ]);

  // Auto-refresh jobs every 5 minutes
  useEffect(() => {
    const intervalId = setInterval(() => {
      const q = searchParams.toString();
      if (!isConfirmDialogOpen && q.length > 0) {
        dispatch(getMangeDataAction({ mode: 'job', query: q }));
        dispatch(getCount({ mode: "job" }));
      }
    }, 300000); // 5 minutes
    return () => clearInterval(intervalId);
    // Restart interval when query dependencies change
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    deps.pageSize,
    deps.pageNumber,
    deps.sortOrder,
    deps.sortBy,
    deps.mixSearch,
    deps.status,
    deps.startDate,
    deps.endDate,
    isConfirmDialogOpen,
  ]);


  
  const onFilterChanged = () => {
    // Scroll to table on filter submit/change
    if (dataGridPaperRef.current) {
      dataGridPaperRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  dispatch(getMangeDataAction({ mode: 'job', query: searchParams.toString() }));
  };


      const handleCardClick = (name, id) => {
        if (name === 'Preparing Vehicles Today') {
          setSearchParams(prev => {
            const next = new URLSearchParams(prev);
            next.set('Status', 'Preparing Vehicles');
            next.set('StartDate', new Date().toISOString().split('T')[0]);
            next.set('EndDate', new Date().toISOString().split('T')[0]);
            next.set('View', 'board');
            next.set('PageNumber', '0');
            next.set('PageSize', '5');
            return next;
          });



        }
        if (name === 'Loading Vehicles Today') {

          setSearchParams(prev => {
            const next = new URLSearchParams(prev);
            next.set('Status', 'Loading Vehicles');
            next.set('StartDate', new Date().toISOString().split('T')[0]);
            next.set('EndDate', new Date().toISOString().split('T')[0]);
            next.set('View', 'board');
        
            return next;
          });

        }


        if (name === 'Preparing Job Late') {
          const yesterday = new Date();
          yesterday.setDate(yesterday.getDate() - 1);
          const yStr = yesterday.toISOString().split('T')[0];

          setSearchParams((prev) => {
            const next = new URLSearchParams(prev);
            next.set('Status', 'Preparing Vehicles');
            next.set('StartDate', '1988-06-01'); // earliest baseline
            next.set('EndDate', yStr); // up to yesterday
            next.set('View', 'board');
            next.set('PageNumber', '0');
            next.set('PageSize', '5');
            return next;
          });
        }




        
        if (name === 'Loading Job Late') {
          const yesterday = new Date();
          yesterday.setDate(yesterday.getDate() - 1);
          const yStr = yesterday.toISOString().split('T')[0];

          setSearchParams((prev) => {
            const next = new URLSearchParams(prev);
            next.set('Status', 'Loading Vehicles');
            next.set('StartDate', '1988-06-01'); // earliest baseline
            next.set('EndDate', yStr); // up to yesterday
            next.set('View', 'board');
            next.set('PageNumber', '0');
            next.set('PageSize', '5');
            return next;
          });
        }




        if (name === 'Finished Last Week')  {

          const lastWeek = new Date();
          lastWeek.setDate(lastWeek.getDate() - 7);
          const lastWeekStr = lastWeek.toISOString().split('T')[0];

          setSearchParams(prev => {
            const next = new URLSearchParams(prev);
            next.set('Status', 'Finished');
            next.set('StartDate', lastWeekStr);
            next.set('EndDate', new Date().toISOString().split('T')[0]);
            next.set('View', 'board');
            next.set('PageNumber', '0');
            next.set('PageSize', '5');
            return next;
          });

        }

        if (name === 'Canceled')  {
          setSearchParams(prev => {
            const next = new URLSearchParams(prev);
            next.set('Status', 'Canceled');
            next.set('View', 'board');
            next.set('PageNumber', '0');
            next.set('PageSize', '5');
            return next;
          });

        }

        if (name === 'Canceled')  {
          setSearchParams(prev => {
            const next = new URLSearchParams(prev);
            next.set('Status', 'Canceled');
            next.set('View', 'board');
            next.set('PageNumber', '0');
            next.set('PageSize', '5');
            return next;
          });


        }

      }


  const view = (searchParams.get('View') || 'board').toLowerCase();
  const jobsPageRaw = jobsLegacy.getManage?.object || {};
  const jobsPage = jobsPageRaw?.body && (Array.isArray(jobsPageRaw.body.content) || typeof jobsPageRaw.body.totalElements === 'number')
    ? jobsPageRaw.body
    : jobsPageRaw;
  const jobsContent = jobsPage?.content || [];
  const printFilters = {
    Status: searchParams.get('Status'),
    StartDate: searchParams.get('StartDate'),
    EndDate: searchParams.get('EndDate'),
    MixSearch: searchParams.get('MixSearch'),
    SortBy: searchParams.get('SortBy'),
    SortOrder: searchParams.get('SortOrder'),
  };
  const handlePrintPreview = (includeSummary = true) => {
    setPrintMenuAnchor(null);
    exportJobsResultsPDF(jobsContent, printFilters, {
      mode: 'preview',
      includeSummary,
      filename: `jobs_results_${new Date().toISOString().slice(0, 10)}.pdf`,
    });
  };

  return (
    <Box sx={{ width: '100%', bgcolor: '#F7F8FA', minHeight: '100vh', p: { xs: 0, md: 2 } }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 3, mt: { xs: 2, md: 0 } }}>
        <WorkIcon sx={{ color: '#0B3C5D', fontSize: 36 }} />
        <Typography variant="h4" sx={{ color: '#0B3C5D', fontWeight: 800, letterSpacing: 1 }}>
          Jobs
        </Typography>
      </Box>
      

      <Paper
        sx={{
          p: { xs: 1, md: 3 },
          minHeight: 180,
          flexGrow: 1,
          background: 'linear-gradient(135deg, #f8fafc 0%, #e9ecef 100%)',
          borderRadius: 4,
          boxShadow: '0 8px 32px 0 rgba(11, 60, 93, 0.10)',
          border: '1px solid #e9ecef',
          mb: 3,
        }}
        anchorEl={anchor}
      >
        {countReducer.loading === 'pending' || countReducer.loading === 'idle' ? (
          <Progress />
        ) : (
          <Box>
            <Box sx={{ display: 'flex', mt: 2, justifyContent: 'center', flexWrap: 'wrap', gap: 3 }}>
              {countReducer.Object?.map((item, index) => {
                const circleColor = ['#0B3C5D', '#D9B310', '#1A5F8C', '#A98A0C', '#F3D351', '#051E30'][index % 6];
                const textColor = index % 6 === 0 || index % 6 === 2 || index % 6 === 5 ? '#fff' : '#0B3C5D';
                return (
                  <Box
                    key={index}
                    sx={{
                      width: 130,
                      height: 170,
                      borderRadius: 4,
                      background: '#fff',
                      boxShadow: '0 2px 8px 0 rgba(11, 60, 93, 0.08)',
                      border: '1px solid #e9ecef',
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      justifyContent: 'flex-start',
                      position: 'relative',
                      overflow: 'hidden',
                      transition: 'transform 0.18s, box-shadow 0.18s',
                      '&:hover': {
                        transform: 'scale(1.06)',
                        boxShadow: '0 8px 24px 0 rgba(11, 60, 93, 0.16)',
                      },
                      cursor: 'pointer',
                      p: 0,
                    }}
                    onClick={() => handleCardClick(item.type, item.id)}
                  >
                    <Box
                      sx={{
                        width: 68,
                        height: 68,
                        borderRadius: '50%',
                        background: `linear-gradient(135deg, ${circleColor} 60%, #fff 100%)`,
                        boxShadow: '0 2px 8px 0 rgba(11, 60, 93, 0.10)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        mt: 2,
                        mb: 1.5,
                      }}
                    >
                      <Typography
                        variant="h4"
                        sx={{
                          color: textColor,
                          fontWeight: 800,
                          fontSize: 30,
                          textShadow: textColor === '#fff' ? '0 1px 4px #0B3C5D55' : 'none',
                        }}
                      >
                        <AnimatedNumbers
                          animateToNumber={item.count}
                          fontStyle={{ fontSize: 30 }}
                          configs={(number, index) => {
                            return { mass: 1, tension: 230 * (index + 1), friction: 50 };
                          }}
                        />
                      </Typography>
                    </Box>

                    <Typography sx={{ color: '#0B3C5D', fontWeight: 700, fontSize: 16, textAlign: 'center', px: 1, mb: 1 }}>
                      {item.name}
                    </Typography>
                  </Box>
                );
              })}
            </Box>
          </Box>
        )}
      </Paper>

     

      <Paper
        ref={dataGridPaperRef}
        sx={{
          p: { xs: 1, md: 3 },
          minHeight: 200,
          flexGrow: 1,
          mt: 3,
          background: '#fff',
          borderRadius: 4,
          boxShadow: '0 8px 32px 0 rgba(11, 60, 93, 0.10)',
          border: '1px solid #e9ecef',
        }}
      >
                <JobsFilter onApply={onFilterChanged} />

        <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1, gap: 2, flexWrap: 'wrap' }}>
          <JobsStatusToggle />
          <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1, flexWrap: 'wrap' }}>
            <Tooltip title={jobsContent.length ? 'Print preview current results' : 'No results to print'} arrow>
              <span>
                <Button
                  size="small"
                  variant="outlined"
                  startIcon={<PictureAsPdfIcon />}
                  endIcon={<KeyboardArrowDownIcon />}
                  onClick={(event) => setPrintMenuAnchor(event.currentTarget)}
                  disabled={!jobsContent.length || jobsLegacy.getManage.loading === 'pending'}
                  sx={{ textTransform: 'none', fontWeight: 700 }}
                >
                  Print Preview
                </Button>
              </span>
            </Tooltip>
            <Menu
              anchorEl={printMenuAnchor}
              open={Boolean(printMenuAnchor)}
              onClose={() => setPrintMenuAnchor(null)}
              anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
              transformOrigin={{ vertical: 'top', horizontal: 'right' }}
            >
              <MenuItem onClick={() => handlePrintPreview(true)}>
                With search summary
              </MenuItem>
              <MenuItem onClick={() => handlePrintPreview(false)}>
                Jobs details only
              </MenuItem>
            </Menu>
            <JobsViewToggle />
          </Box>
        </Box>

        <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2, flexWrap: 'wrap' }}>
          <DatePresetsToggle onApply={onFilterChanged} />
          <JobsSortToggle />
        </Box>

        {jobsLegacy.getManage.loading === 'pending' || jobsLegacy.getManage.loading === 'idle' ? (
          <Progress Msg="Loading ..." />
        ) : view === 'board' ? (
          <JobsBoard onConfirmDialogOpenChange={setConfirmDialogOpen} />
        ) : view === 'cards' ? (
          <JobsCards onConfirmDialogOpenChange={setConfirmDialogOpen} />
        ) : (
          <JobsTable onConfirmDialogOpenChange={setConfirmDialogOpen} />
        )}
      </Paper>
    </Box>
  );
}

export default Jobs;
